<template>
  <div class="row">
    <base-editor
      :mpeStriped="mpeStriped"
      :basic="basic"
      :submitDisabled="submitDisabled"
      @updateField="updateMpeParams"
      @saveChanges="saveChanges"
      @discardChanges="discardChanges"
      @duplicateMpe="duplicateMpe">

      <!-- All of this is for facebok WYSIWYG -->
      <div slot="post-content">
        <h3 class="mt-1">
          {{ $t('Button.edit') }}
        </h3>

        <slot
          :params="getPayload"
          name="above" />

        <component
          :is="componentByType"
          :payload="getPayload"
          :availableImages="getAvailableImages"
          :selectedImages="getSelectedImages"
          v-on="$listeners" />

      </div>
    </base-editor>

    <div class="col-5 mpe-preview">
      <channel-preview
        :channel="makePreviewChannel"
        :mpe="makePreviewMpe" />

    </div>
  </div>
</template>

<script>

import { FacebookPost, SqwizArticle, TwitterTweet, InformacijaPost, WordpressPost, SqwizProduct, InformacijaProduct, WoocommerceProduct } from './type/index'
import Base from '@/components/standard/formatter/Base'
import formatterBase from '@/mixins/campaigns/mpeEditor/formatterBase.js'
import Preview from '@/components/standard/display/channelPreview/Preview'

import pe from '@/assets/modules/channels/paramExtractor'
import { getMediaFieldName } from '@/assets/modules/error/resolver'

export default {
  computed: {
    /**
     * Gives component based on given type
     * @returns {String}
     */
    componentByType () {
      if (!this.getMpeType) return
      return `${this.getMpeType[0].toUpperCase()}${this.getMpeType.slice(1)}`
    },

    /**
     * Gives mpe's type
     * @returns {String}
     */
    getMpeType () {
      return this.mpeStriped.type
    },

    /**
     * Gives channel's type
     * @returns {String}
     */
    getChannelType () {
      return pe.postTypeToChannelType(this.getMpeType)
    },

    /**
     * Gives preview vhannel object
     * @returns {Object}
     */
    makePreviewChannel () {
      return { type: this.getChannelType }
    },

    /**
     * Prepares a preview mpe from given components
     * @returns {Object}
     */
    makePreviewMpe () {
      // Get media...
      let mappedMedia = this.availableMedia.reduce((prev, cur) => {
        prev[cur.uuid] = cur.url
        return prev
      }, {})

      let media = this.selectedMedia.reduce((prev, cur) => {
        prev.push({ url: mappedMedia[cur] })
        return prev
      }, [])

      // Payload
      let payload = this.getPayload
      let mediaField = getMediaFieldName(this.getMpeType)
      payload[mediaField] = media

      // All together
      let rtr = {}
      rtr[this.getMpeType] = payload
      rtr.type = this.getMpeType

      return rtr
    }
  },

  components: {
    FacebookPost,
    SqwizArticle,
    TwitterTweet,
    InformacijaPost,
    WordpressPost,
    SqwizProduct,
    InformacijaProduct,
    WoocommerceProduct,
    'base-editor': Base,
    'channel-preview': Preview
  },

  props: {
    submitDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mixins: [
    formatterBase
  ]
}
</script>

<style scoped>
.sqwiz-box {
  border-radius: 3px;
  border: 1px solid rgb(153, 153, 153);
}
.scheduled-at {
  margin: 12px 0;
  padding: 0 12px;
  color: #D6D6D6;
  font-style: italic;
}

.sarticle-body {
  padding: 0 12px;
}

.sm-items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 20px 0 4px 0;
  padding: 0 12px;
}
.sm-item {
  margin: 1px;
  padding: 2px;
  color: rgb(51, 51, 51);
  cursor: pointer;
}

.like-button {
  padding: 0 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 48px;
  border: 0;
  outline: 0;
  background-color: rgb(66, 103, 178);
  border-radius: 3px;
  color: #ffffff;
  height: 17px;
  font-size: 12px;
}
.gb-like {
  margin-right: 15px;
}

.part {
  display: flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/formatter/BasicFormatter.vue?31eead98